export enum RegistrySort {
  TitleAZ = 'title',
  TitleZA = '-title',
  RegisteredOldest = 'date_registered',
  RegisteredNewest = '-date_registered',
}
